import { For } from 'solid-js';
import { cornerCropMarks, MARK_STROKE_MM } from '../core/marks';

export function CornerCropMarks() {
  const marks = cornerCropMarks();
  return (
    <g class="corner-crop-marks" stroke="#000" stroke-width={MARK_STROKE_MM} fill="none">
      <For each={marks}>
        {corner => (
          <For each={corner.segments}>
            {seg => <line x1={seg.x1} y1={seg.y1} x2={seg.x2} y2={seg.y2} />}
          </For>
        )}
      </For>
    </g>
  );
}
